__webpack_require__.p = "/firebase-authentication/";